{ "id": "qa2000-accel", "name": "Honeywell QA2000 class (navigation-grade accel)", "domain": "accel", "states": 3,
  "coefs": { "Q": 0, "F": 0, "N": 10, "B": 15, "K": 0, "D": 0, "R": 0 },
  "thermal": { "tempco": 15, "tauTh": 300 },
  "source": "QA2000 class; N, B, tempco inferred from published performance class, not a datasheet.",
  "inferred": ["N", "B", "tempco"] }
